/**
@ngdoc service
@name ajaxCall
@description
GET and POST calls factory (if only postData parameter POST request is being done)
@param {boolean=} useFormData - POST data will be send as FormData object (ie. for ajax files upload)
*/

(function() {
    'use strict';

	var ajaxCall = function($http, $httpParamSerializer, $q, transformToFormPost) {
   		return {

			// ajax call
            getData: function(url, postData, useFormData) {

                var request,
                    defer = $q.defer();

                function isNumeric(n) {
                    return !isNaN(parseFloat(n)) && isFinite(n);
                }

                if( !angular.isDefined(postData) ) {
                    // just make GET request
                    request = $http({
                        method: "get",
                        url: url,
                        timeout: defer.promise
                    });

                } else {

                    if(!angular.isDefined(useFormData) || useFormData!==true){
                        // POST request
                        if( angular.isObject(postData) ){
                            // if it's object we "stringify" data
                            postData = $httpParamSerializer(postData);
                        }
                        // POST call
                        request = $http({
                            method: "post",
                            url: url,
                            transformRequest: transformToFormPost, // TODO: postData
                            data: postData,
                            timeout: defer.promise
                        });
                    } else {

                        // FormData() request
                        var formdata = new FormData();
                        var traverseDataObject = function(o, parentKey) {
                            for (var i in o) {
                                if( o.hasOwnProperty(i) ) {
                                    var extendedKey = angular.isDefined(parentKey) ? parentKey + (isNumeric(i) ? '['+i+']' : '.'+i) : i; // the result is path.key or path[key]
                                    var childObj = o[i];
                                    formdata.append(extendedKey, childObj); // append FormData()
                                    if( traversableData(childObj) ) {
                                        //going one step down in the object tree
                                        traverseDataObject(childObj, extendedKey);
                                    }
                                }
                            }
                        };
                        traverseDataObject(postData);

                        request = $http({ // should be there
                            method: 'POST',
                            url: url,
                            data: formdata,
                            timeout: defer.promise,
                            headers: {
                                'Content-Type': undefined // required for file upload
                            }
                        });
                    }

                }

                function traversableData(obj){
                    return obj !== null && ["object","array"].includes( toType(obj) );
                }

                //X3-21162
                function toType(obj) {
                    return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
                }

                // we want to be able to cancel / abort http request! hence below
                // http://stackoverflow.com/questions/24440177/angularjs-how-to-cancel-resource-promise-when-switching-routes

                // Rather than returning the http-promise object, we want to pipe it
                // through another promise so that we can "unwrap" the response
                // without letting the http-transport mechansim leak out of the
                // service layer.
                var promise = request.then(
                    function(response) {
                        return( $q.resolve(response) );
                    },
                    function(response) {
                        return( $q.reject(response) );
                    }
                );

                // Now that we have the promise that we're going to return to the
                // calling context, let's augment it with the abort method. Since
                // the $http service uses a deferred value for the timeout, then
                // all we have to do here is resolve the value and AngularJS will
                // abort the underlying AJAX request.
                promise.abort = function(reason) {
                    if (!cssua.ua.ie || cssua.ua.ie > 9.0) {
                        defer.resolve(reason);
                    }
                };

                // Since we're creating functions and passing them out of scope,
                // we're creating object references that may be hard to garbage
                // collect. As such, we can perform some clean-up once we know
                // that the requests has finished.
                promise.finally(function() {
                    if (!cssua.ua.ie || cssua.ua.ie > 9.0) {
                        promise.abort = angular.noop;
                        defer = request = promise = null;
                    }
                }).catch(function(request){
                    // Possibly unhandled rejection fix (introduced by Angular 1.6)
                    console.log(request);
                });

                return( promise );
            }


        }



    }

    ajaxCall.$inject = ['$http', '$httpParamSerializer', '$q', 'transformToFormPost'];
    angular.module('app').factory('ajaxCall', ajaxCall);

}());